import THREE from '../utils/threeClassesAdapter';
// eslint-disable-next-line camelcase
import time_pars_common from './ShaderChunk/time_pars_common.glsl';
// eslint-disable-next-line camelcase
import noise_func from './ShaderChunk/noise_func.glsl';
// eslint-disable-next-line camelcase
import smoothmix_func from './ShaderChunk/smoothmix_func.glsl';
// eslint-disable-next-line camelcase
import rotation_mat3_func from './ShaderChunk/rotation_mat3_func.glsl';
// eslint-disable-next-line camelcase
import minimal_frag from './ShaderChunk/minimal_frag.glsl';
// eslint-disable-next-line camelcase
import minimal_vert from './ShaderChunk/minimal_vert.glsl';
// eslint-disable-next-line camelcase
import minimal_uv_vert from './ShaderChunk/minimal_uv_vert.glsl';
// eslint-disable-next-line camelcase
import test_uv_frag from './ShaderChunk/test_uv_frag.glsl';
// eslint-disable-next-line camelcase
import gradientbackground_frag from './ShaderChunk/gradientbackground_frag.glsl';
// eslint-disable-next-line camelcase
import gradient_linear_func from './ShaderChunk/gradient_linear_func.glsl';
// eslint-disable-next-line camelcase
import gradient_linear_progress_color from './ShaderChunk/gradient_linear_progress_color.glsl';
// eslint-disable-next-line camelcase
import gradient_pars_frag from './ShaderChunk/gradient_pars_frag.glsl';
// eslint-disable-next-line camelcase
import resolution_pars_common from './ShaderChunk/resolution_pars_common.glsl';
// eslint-disable-next-line camelcase
import meshtext2_frag from './ShaderChunk/meshtext2_frag.glsl';
// eslint-disable-next-line camelcase
import meshtext2_vert from './ShaderChunk/meshtext2_vert.glsl';
// eslint-disable-next-line camelcase
import meshtext2bent_vert from './ShaderChunk/meshtext2bent_vert.glsl';
// eslint-disable-next-line camelcase
import flag_meshmatcap_frag from './ShaderChunk/flag_meshmatcap_frag.glsl';
// eslint-disable-next-line camelcase
import flag_meshmatcap_vert from './ShaderChunk/flag_meshmatcap_vert.glsl';

export const ShaderChunk = {
    // eslint-disable-next-line camelcase
    minimal_frag,
    // eslint-disable-next-line camelcase
    minimal_vert,
    // eslint-disable-next-line camelcase
    minimal_uv_vert,
    // eslint-disable-next-line camelcase
    test_uv_frag,
    // eslint-disable-next-line camelcase
    gradientbackground_frag,
    // eslint-disable-next-line camelcase
    meshtext2_frag,
    // eslint-disable-next-line camelcase
    meshtext2_vert,
    // eslint-disable-next-line camelcase
    meshtext2bent_vert,
    // eslint-disable-next-line camelcase
    flag_meshmatcap_frag,
    // eslint-disable-next-line camelcase
    flag_meshmatcap_vert
};

export const initShaderChunk = () => {
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.time_pars_common = time_pars_common;
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.noise_func = noise_func;
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.smoothmix_func = smoothmix_func;
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.rotation_mat3_func = rotation_mat3_func;
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.gradient_linear_func = gradient_linear_func;
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.gradient_linear_progress_color = gradient_linear_progress_color;
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.gradient_pars_frag = gradient_pars_frag;
    // eslint-disable-next-line camelcase
    THREE.ShaderChunk.resolution_pars_common = resolution_pars_common;
};
